"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileDown = void 0;
const react_1 = __importDefault(require("react"));
const Colors_1 = require("../../Colors");
const GlobalStateProvider_1 = require("../../GlobalStateProvider");
const element_1 = require("../element");
exports.FileDown = react_1.default.memo(({ files, isOpen, allowAlways = false }) => {
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const downloadFile = (url) => {
        const formattedUrl = url.replace(/\s/g, '%20');
        const a = document.createElement('a');
        a.href = formattedUrl; // 다운로드 URL 설정
        a.download = url.split('/').pop() || 'download'; // 다운로드 파일명 설정
        document.body.appendChild(a); // a 요소를 문서에 추가
        a.click();
        document.body.removeChild(a); // a 요소를 문서에서 제거
    };
    return !files || (files && files.length <= 0) ? (react_1.default.createElement("div", { className: "value" }, " - ")) : (files?.map((item, index) => (react_1.default.createElement(element_1.Button, { key: index, className: `btn_sliver md_round center body5 cursor attach_item`, text: typeof item === 'string'
            ? item.split('/')[item.split('/').length - 1]
            : //@ts-ignore
                item.name, styles: {
            buttonWrap: {
                height: 'fit-content',
                maxWidth: isMobile ? 180 : 220,
            },
        }, option: {
            buttonBeforeIcon: {
                name: 'file',
                color: Colors_1.Colors.w_grey,
                size: isMobile ? 12 : 20,
                show: true,
            },
        }, onClick: isOpen || allowAlways
            ? () => downloadFile(item)
            : () => alert('진행 기간에만 다운로드 가능합니다.') }))));
});
